"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlWithProtocol = exports.getDomainFromUrl = void 0;
const getDomainFromUrl = url => {
  return url.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0];
};
exports.getDomainFromUrl = getDomainFromUrl;
const getUrlWithProtocol = url => {
  if (url.startsWith('http') || url.startsWith('//')) {
    return url;
  } else {
    return 'https://' + url;
  }
};
exports.getUrlWithProtocol = getUrlWithProtocol;